import { call, fork, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

import {
    DeleteFileError,
    DeleteFilesListStart,
    DeleteFileStart,
    DeleteFileSuccess,
    FileLoadError,
    FileLoadSuccess,
    StartFileLoad,
} from '@/store/userfiles/actions';
import { DeleteFileAction, DeleteFilesListAction } from '@/store/userfiles/types';
import { deleteFile as remove, deleteFiles as removeFiles, loadFiles as load } from '@/services/ElasticApi';
import { ApplicationState as State } from '@/store';
import { UserFilesState } from '@/store/userfiles/types';
import { HideToast, ShowToast } from '@/store/toast/actions';

import i18n from '@/../i18n';
import { Logger } from '@/services/errors/appLogger';

const getUserFiles = (state: State): UserFilesState => state.userFiles;

function* loadFiles(): any {
    yield put(StartFileLoad());

    try {
        const files = yield call(load);
        yield put(FileLoadSuccess(files));
    } catch (e) {
        console.log(e);
        Logger.error(e?.response?.data?.Error);
        yield put(FileLoadError());
    }
}

function* deleteFile(action: DeleteFileAction): any {
    const { payload } = action;

    yield put(DeleteFileStart());

    try {
        const resp = yield call(remove, payload.fileNameToDelete); // eslint-disable-line

        const userFiles = yield select(getUserFiles);
        const { files } = userFiles;
        const toastMessage = payload.imageDelete ? i18n.t('imagedeleted') : i18n.t('filedeleted');

        yield put(DeleteFileSuccess(files.filter((o): boolean => o.FileName !== payload.fileNameToDelete)));
        yield put(
            ShowToast({
                severity: 'info',
                message: toastMessage,
                duration: 6000,
                onClose: HideToast,
            })
        );
    } catch (e) {
        Logger.error(e?.response?.data?.Error);
        yield put(DeleteFileError());
    }
}

function* deleteFilesList(action: DeleteFilesListAction): any {
    const {
        payload: { filesToDelete, imagesDelete },
    } = action;

    yield put(DeleteFilesListStart());

    try {
        yield call(removeFiles, filesToDelete);

        const userFiles = yield select(getUserFiles);
        const { files } = userFiles;
        const toastMessage = imagesDelete ? i18n.t('imagesdeleted') : i18n.t('filesdeleted');

        yield put(DeleteFileSuccess(files.filter((o) => !filesToDelete.includes(o.FileName))));
        yield put(
            ShowToast({
                severity: 'info',
                message: toastMessage,
                duration: 6000,
                onClose: HideToast,
            })
        );
    } catch (e) {
        Logger.error(e?.response?.data?.Error);
        yield put(DeleteFileError());

        yield put(
            ShowToast({
                severity: 'error',
                message: `Error: ${e?.response?.data?.Error}`,
                duration: 6000,
                onClose: HideToast,
            })
        );
    }
}

function* watchLoad(): any {
    yield takeLatest(['@@userFiles/LOAD_USER_FILES'], loadFiles);
}

function* watchDelete(): any {
    yield takeEvery('@@userFiles/DELETE_FILE', deleteFile);
}

function* watchDeleteFilesList(): any {
    yield takeEvery('@@userFiles/DELETE_FILES_LIST', deleteFilesList);
}

const fileSagas = [fork(watchLoad), fork(watchDelete), fork(watchDeleteFilesList)];

export default fileSagas;
